import { ASSETS } from '@/utils/constants'
export default {
  data () {
    return {
      assets: ASSETS
    }
  },
  methods: {
    walletAddressDetail (currency) {
      if (this.walletAddresses) {
        const walletId = this.walletAddresses.find(
          (wallet) =>
            wallet.asset === currency &&
            wallet.reason === this.$transactionType.DEPOSIT
        )
        if (!walletId) {
          return `Yet to register ${currency} for deposit`
        }
      } else {
        return 'Your account is awaiting further verification. Once that is done the disabled payment method would be enabled.'
      }
    },
    hasWalletAddress (currency) {
      const selectedCurrency = this.assets.find(
        (element) => element.currency === currency
      )
      if (selectedCurrency && this.walletAddresses.length > 0) {
        const walletId =
          this.$store.state.transactions.walletAddresses.items.find(
            (wallet) =>
              wallet.asset === currency &&
              wallet.reason === this.$transactionType.DEPOSIT
          )
        return !walletId
      } else {
        return false
      }
    },
    async initiateSwapDeposit (twoFaCode) {
      const vm = this
      const payload = {
        amount: this.swapDetails.amount,
        toCurrency: this.swapDetails.toCurrency,
        fromCurrency: this.swapDetails.fromCurrency,
        twoFaCode: twoFaCode
      }
      await this.$store
        .dispatch('transactions/initiateSwapFunds', payload)
        .then(() => {
          this.showVerifyAuthDialog = false
          this.$nextTick(() => {
            this.showSuccessDialog = true
          })
        })
        .catch((error) => {
          this.handleErrorResponseNotification(error)
        })
        .finally(() => {
          this.showVerifyAuthDialog = false
          this.refreshPage()
        })
    }
  },
  computed: {
    walletAddresses () {
      return this.$store.state.transactions.walletAddresses.items || []
    },
    swapDetails () {
      return this.$store.state.transactions.swapDetails
    }
  }
}
